import { createIntl, createIntlCache } from 'react-intl';

const cache = createIntlCache();

const createNewIntl = (language: string, messages: Record<string, string>) =>
  createIntl(
    {
      locale: language,
      messages,
      onError: () => {
        /* This is intentionally empty as it's a placeholder that gets replaced later */
      },
    },
    cache,
  );

export { createNewIntl };
